type PlausibleEvent =
  | 'Click B2B Get Started'
  | 'Click B2C Get Started'
  | 'Newsletter Sign Up'
  | 'FAQ Toggle';

type PlausibleEventProps = Record<string, string | number | boolean>;

declare global {
  interface Window {
    plausible?: (
      event: string,
      options?: { props: PlausibleEventProps }
    ) => void;
  }
}

export function trackPlausibleEvent(
  event: PlausibleEvent,
  props?: PlausibleEventProps
) {
  if (typeof window.plausible === 'function') {
    window.plausible(event, props ? { props } : undefined);
  }
}
